import api from '@/api';
import router from '@/router/router'

export const actions = {

    authCurrentUser({dispatch, commit}) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({url: 'current-user', method: 'GET'})
                .then(resp => {
                    commit('authStoreCurrentUser', resp.data);
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    commit('resetState');
                    reject(err)
                })
        });
    },

    authImpersonate({dispatch, commit}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({url: 'users/impersonate', data: data, method: 'POST'})
                .then(resp => {
                    commit('authStoreCurrentUser', resp.data.user);
                    commit('authSwitchImpersonateToken', resp.data.access_token);
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        });
    },

    authLogin({dispatch, commit}, data) {
        return new Promise((resolve, reject) => {

            dispatch('commonStartLoading');
            commit('resetState');
            data.grant_type = process.env.VUE_APP_OAUTH_GRANT_TYPE;
            data.client_id = process.env.VUE_APP_OAUTH_CLIENT_ID;
            data.client_secret = process.env.VUE_APP_OAUTH_CLIENT_SECRET;
            data.scope = process.env.VUE_APP_OAUTH_SCOPE;

            api({url: 'oauth/token', data: data, method: 'POST'})
                .then(resp => {
                    commit('authStoreAccessToken', resp.data.access_token);
                    commit('authStoreRefreshToken', resp.data.refresh_token);
                    commit('authStoreCurrentUser', resp.data.user);
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    commit('resetState');
                    reject(err)
                })
        })
    },

    authSaveSociety({dispatch, commit}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({url: 'store-society', data: data, method: 'POST'})
                .then(resp => {
                    commit('authStoreCurrentUser', resp.data.user);
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err.data)
                })
        })
    },

    authResetPassword({dispatch}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({url: 'users/reset-password', data: data, method: 'POST'})
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        })
    },

    authRecoveryPasswordByEmail({dispatch}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({url: 'recovery-password', data: data, method: 'POST'})
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        })
    },

    authUpdatePassword({dispatch, commit}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({url: 'users/update-password', data: data, method: 'POST'})
                .then(resp => {
                    dispatch('commonEndLoading');
                    commit('authStoreCurrentUser', resp.data);
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        })
    },

    authLogout({dispatch, commit}, data) {
        return new Promise((resolve) => {
            dispatch('resetState');
            commit('resetState');
            delete api.defaults.headers.common['Authorization'];
            if(!data) {
                router.push({name: 'auth.login'});
            }
            resolve()
        })
    },

    authRefreshToken({commit, state}) {
        return new Promise((resolve, reject) => {

            const data = {};
            data.grant_type = process.env.VUE_APP_OAUTH_GRANT_REFRESH_TOKEN;
            data.client_id = process.env.VUE_APP_OAUTH_CLIENT_ID;
            data.client_secret = process.env.VUE_APP_OAUTH_CLIENT_SECRET;
            data.scope = process.env.VUE_APP_OAUTH_SCOPE;
            data.refresh_token = state.refreshToken;

            api({url: 'oauth/token', data: data, method: 'POST'})
                .then(resp => {
                    commit('authStoreAccessToken', resp.data.access_token);
                    commit('authStoreRefreshToken', resp.data.refresh_token);
                    resolve(resp.data);
                })
                .catch(err => {
                    commit('resetState');
                    reject(err)
                })
        })
    },

};
